export enum Header {
  AUTHORIZATION = 'authorization',
  SELECTED_ACCOUNT_ID = 'x-selected-account-id',
  AUTH_TYPE = 'x-auth-type',
  SESSION_ID = 'session-id',
}
